import {createRouter, createWebHistory} from 'vue-router';
import NProgress from '../components/nprogress'; // 加载进度条
import index from './modules';
import store from "@/store";
import {getCartNum, getUserByToken} from "@/api/users";
import {getInstitution} from "@/api/sys";
import {Toast} from 'vant';
import {doLogout, isNotEmpty} from "@/utils/util";
import Axios from "axios";

const routes = [
    {
        path: '',
        redirect: '/index'
    },
    {
        path: '/login', // 登录
        name: 'Login',
        component: () => import('@/views/Login.vue'),
        meta: {
            title: '登录'
        }
    },
    index,
    {
        path: '/tokenError',//获取用户信息失败
        component: () => import('@/views/TokenError.vue'),
    },
    {
        path: '/error',
        component: () => import('@/views/Error.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue')
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

/**
 * 前置钩子
 */
// 处理默认配置
router.beforeEach((to, from, next) => {
    if(!store.state.config.local){
        // 此配置需要在最开始进入项目就获取
        Axios.get('/pdam/app/app.config.json')
            .then(res => {
                if (isNotEmpty(res) && res && res.data) {
                    store.commit('setConfig', res.data); // 设置默认config数据
                    next();
                } else {
                    //跳转到服务正在维护中, 因为若基本的配置参数都无法获取, 那么整个应用也无法运行起来
                    next({path:'/error'});
                }
            })
            .catch(err =>{
                console.error(err);
                //跳转到服务正在维护中, 因为若基本的配置参数都无法获取, 那么整个应用也无法运行起来
                next({path:'/error'});
            } );
    }
    else{
        next();
    }
});
/**
 * 前置钩子
 */
// token处理
router.beforeEach((to, from, next) => {
    // 进入首页
    handleToken(to,next);
});
// 处理token数据
const handleToken=(to,next)=>{
    const uid = store.state.reader.user.uid;
    if (!uid && to && to.query && to.query.token) {
        const token = String(to.query.token);
        getUserByToken(token)
            .then(data => {
                if (data) {
                    store.commit('setUser', data);
                    getCartNum()
                        .then(data => {
                            store.commit('setCartNum', data);
                        })
                        .catch((error) => {
                            console.error(error);
                        });
                    getInstitution()
                        .then((data) => {
                            if (data) {
                                store.commit('setInstitution', data.instName);
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                        });
                    next();
                } else {
                    console.error('获取用户信息失败');
                    Toast({message: '获取用户信息失败,请稍后重试,3秒后回到首页:'});
                    doLogout();
                }
            })
            .catch((error) => {
                console.error('获取用户信息失败',error);
                Toast({message: '获取用户信息失败,请稍后重试,3秒后回到首页:' + error});
                doLogout();
            });
    } else {
        next();
    }
}
// 登录检测
router.beforeEach((to, from, next) => {
    const uid = store.state.reader.user.uid;
    if (to.meta.loginBlocking && !uid) {
        // 未登录
        let url = store.state.baseConfig['pda.start.url'] ?? store.state.config['pda.start.url'];
        // 不替换当前页面 因为还未进入到想拦截的页面
        window.location.assign(url + to.path);
    } else {
        next();
    }

});
// 滚动位置记录
router.beforeEach((to, from, next) => {
    // 记录页面滚动位置
    if (from.meta.keepAlive) {
        store.commit('setScrollTop', window.pageYOffset);
    }
    next()
})
/**
 * 后置钩子
 */
router.afterEach((to,from) => {
    if (to.meta.keepAlive && to.meta.depth < from.meta.depth ) {
        setTimeout(() => {
            window.scrollTo(0, store.state.scrollTop);// 页面滚动到指定位置
        }, 50)
    } else {
        window.scrollTo(0, 0);
    }
    NProgress.done(); // 结束显示加载进度条
});

export default router;
